import { Feature } from 'geojson';

import { Platform } from '@/types/config/config.types';
import { FeatureTypeEnum } from '@/types/map.types';

const toPerimeterFeature = (platform: Platform): Feature => {
  return {
    type: 'Feature',
    id: `${FeatureTypeEnum.PLATFORM_PERIMETER}-${platform.id}`,
    properties: {
      id: platform.id,
      featureType: FeatureTypeEnum.PLATFORM_PERIMETER,
    },
    geometry: {
      type: 'LineString',
      coordinates: platform.polygon.coordinates[0] ?? [],
    },
  };
};

export const toPlatformPerimeterFeatures = (platforms: Platform[]): Feature[] => {
  return platforms.map((platform) => toPerimeterFeature(platform));
};
